import { GET_ALL_CONTRACT_EMPLOYEE_TYPES } from "./types";

const EmployeeContractTypeReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ALL_CONTRACT_EMPLOYEE_TYPES:
            return {
                ...state,
                contractEmployeeTypes: payload,
                wasFetched: true
            }
        default:
            return state
    }
}

export default EmployeeContractTypeReducer